/* Ayutri - AJAX cart drawer, free gift unlock, upsell, sticky ATC */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var drawer = document.getElementById('CartDrawer');
  var busy = false;

  function open() {
    if (!drawer) return;
    drawer.setAttribute('open-drawer', '');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    if (!drawer) return;
    drawer.removeAttribute('open-drawer');
    document.body.style.overflow = '';
  }
  window.ayutriCartOpen = open;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-cd-close]')) { close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  /* Checkout. Fastrr only scans the DOM once on load, so a re-rendered
     container never gets its button. Call the global directly instead. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cd-checkout]');
    if (!b) return;
    var sr = window.shiprocketCheckoutEvents;
    if (sr && typeof sr.buyCart === 'function') {
      try { sr.buyCart(e); return; } catch (err) { /* fall through */ }
    }
    var f = document.getElementById('CartDrawerForm');
    if (f) f.submit(); else window.location.href = root + 'checkout';
  });

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function qualifying(cart) {
    return cart.items.reduce(function (s, i) {
      return (i.properties && i.properties._gift) ? s : s + i.final_line_price;
    }, 0);
  }

  function giftLineIndex(cart, id) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === id) return i + 1;
    }
    return 0;
  }

  function changeLine(line, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }

  /* Keep the free gift in sync with the unlock threshold. */
  function syncGift() {
    if (!drawer) return Promise.resolve();
    var giftId = parseInt(drawer.getAttribute('data-gift-variant') || '0', 10);
    var giftPrice = parseInt(drawer.getAttribute('data-gift-price') || '0', 10);
    var threshold = parseInt(drawer.getAttribute('data-gift-threshold') || '0', 10);
    if (!giftId || !threshold || giftPrice > 0) return Promise.resolve();

    return getCart().then(function (cart) {
      var total = qualifying(cart);
      var line = giftLineIndex(cart, giftId);
      if (total >= threshold && !line) {
        return addItems([{ id: giftId, quantity: 1, properties: { _gift: 'true' } }]);
      }
      if (total < threshold && line) {
        return changeLine(line, 0);
      }
      return null;
    }).catch(function () {});
  }

  /* Re-render the drawer from Liquid. */
  function refresh(shouldOpen) {
    if (!drawer) return Promise.resolve();
    var id = drawer.getAttribute('data-section-id');
    return fetch(root + '?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('cart-drawer');
        var nextPanel = doc.querySelector('.cd-panel');
        var panel = drawer.querySelector('.cd-panel');
        if (!next || !nextPanel || !panel) return;

        ['data-gift-variant', 'data-gift-price', 'data-gift-threshold', 'data-item-count', 'data-qualifying']
          .forEach(function (attr) {
            var val = next.getAttribute(attr);
            if (val !== null) drawer.setAttribute(attr, val);
          });

        panel.innerHTML = nextPanel.innerHTML;

        var count = next.getAttribute('data-item-count') || '0';
        document.querySelectorAll('.bag-count').forEach(function (el) { el.textContent = count; });
        document.querySelectorAll('[data-tab-cart]').forEach(function (el) {
          el.textContent = 'Cart (' + count + ')';
        });

        if (shouldOpen) open();
      })
      .catch(function () { window.location.href = root + 'cart'; });
  }

  function afterChange(shouldOpen) {
    return syncGift().then(function () { return refresh(shouldOpen); });
  }

  /* Quantity and remove inside the drawer */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cd-qty]');
    if (!b || busy) return;
    busy = true;
    b.disabled = true;
    changeLine(parseInt(b.getAttribute('data-cd-line'), 10), parseInt(b.getAttribute('data-cd-qty'), 10))
      .then(function () { return afterChange(false); })
      .then(function () { busy = false; });
  });

  /* One-tap upsell add */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cd-add]');
    if (!b || busy) return;
    busy = true;
    b.disabled = true;
    b.textContent = 'Adding...';
    addItems([{ id: parseInt(b.getAttribute('data-cd-add'), 10), quantity: 1 }])
      .then(function () { return afterChange(false); })
      .then(function () { busy = false; });
  });

  /* Intercept every add-to-cart form */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || busy) return;
    e.preventDefault();
    busy = true;

    var btn = form.querySelector('[data-add-btn]') || form.querySelector('[type=submit]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        return afterChange(true);
      })
      .catch(function () { form.submit(); })
      .then(function () {
        busy = false;
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  });

  /* /cart opens the drawer instead of a page */
  if (document.body.classList.contains('tpl-cart')) {
    window.addEventListener('load', function () { setTimeout(open, 60); });
  }

  /* Sticky add-to-cart bar on the product page */
  var satc = document.querySelector('.satc');
  var anchor = document.querySelector('[data-satc-anchor]');
  if (satc && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.boundingClientRect.top < 0 && !en.isIntersecting) {
          satc.setAttribute('show', '');
        } else {
          satc.removeAttribute('show');
        }
      });
    }, { rootMargin: '0px' }).observe(anchor);

    satc.querySelectorAll('[data-satc-submit]').forEach(function (b) {
      b.addEventListener('click', function () {
        var f = document.getElementById('pdpForm');
        if (!f) return;
        if (f.requestSubmit) { f.requestSubmit(); } else { f.submit(); }
      });
    });
  }
})();
